module.exports = __webpack_public_path__ + "img/bc-brutkarmarj.7335e056.png";